import { cond, is, map, identity, compose, join, isNil, T, always } from 'ramda';

const msg = (fm, accessor) => id => fm({ id: accessor(id) });

export const localizeValue = (formatMessage, accessor = identity, value) =>
  cond([
    [is(Number), identity],
    [is(Array), compose(join(', '), map(msg(formatMessage, accessor)))],
    [isNil, always('')],
    [T, msg(formatMessage, accessor)],
  ])(value);

export const localizeArray = (fm, value, idAccessor = identity) =>
  is(Array, value) ? compose(join(', '), map(compose(fm, idAccessor)))(value) : null;
